var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      ref: "wrap",
      class: [
        "vue-slider-component",
        _vm.flowDirection,
        _vm.disabledClass,
        _vm.stateClass,
        { "vue-slider-has-label": _vm.piecewiseLabel },
      ],
      style: [_vm.wrapStyles, _vm.boolDisabled ? _vm.disabledStyle : null],
      on: { click: _vm.wrapClick },
    },
    [
      _c(
        "div",
        {
          ref: "elem",
          staticClass: "vue-slider",
          style: [_vm.elemStyles, _vm.bgStyle],
          attrs: { "aria-hidden": "true" },
        },
        [
          _vm.isRange
            ? [
                _c(
                  "div",
                  {
                    key: "dot0",
                    ref: "dot0",
                    class: [
                      _vm.tooltipStatus,
                      "vue-slider-dot",
                      {
                        "vue-slider-dot-focus":
                          _vm.focusFlag && _vm.focusSlider === 0,
                        "vue-slider-dot-dragging":
                          _vm.flag && _vm.currentSlider === 0,
                        "vue-slider-dot-disabled":
                          !_vm.boolDisabled && _vm.disabledArray[0],
                      },
                    ],
                    style: _vm.dotStyles,
                    on: {
                      mousedown: function ($event) {
                        return _vm.moveStart($event, 0)
                      },
                      touchstart: function ($event) {
                        return _vm.moveStart($event, 0)
                      },
                    },
                  },
                  [
                    _vm._t(
                      "dot",
                      [
                        _c("div", {
                          staticClass: "vue-slider-dot-handle",
                          style: [
                            !_vm.boolDisabled && _vm.disabledArray[0]
                              ? _vm.disabledDotStyles[0]
                              : null,
                            _vm.sliderStyles[0],
                            _vm.focusFlag && _vm.focusSlider === 0
                              ? _vm.focusStyles[0]
                              : null,
                          ],
                        }),
                      ],
                      {
                        value: _vm.val[0],
                        index: 0,
                        disabled: _vm.disabledArray[0],
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "tooltip0",
                        class: [
                          "vue-slider-tooltip-" + _vm.tooltipDirection[0],
                          "vue-slider-tooltip-wrap",
                        ],
                      },
                      [
                        _vm._t(
                          "tooltip",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "vue-slider-tooltip",
                                class: _vm.tooltipClass,
                                style: _vm.tooltipStyles[0],
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatter
                                      ? _vm.formatting(_vm.val[0])
                                      : _vm.val[0]
                                  )
                                ),
                              ]
                            ),
                          ],
                          {
                            value: _vm.val[0],
                            index: 0,
                            disabled: !_vm.boolDisabled && _vm.disabledArray[0],
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    key: "dot1",
                    ref: "dot1",
                    class: [
                      _vm.tooltipStatus,
                      "vue-slider-dot",
                      {
                        "vue-slider-dot-focus":
                          _vm.focusFlag && _vm.focusSlider === 1,
                        "vue-slider-dot-dragging":
                          _vm.flag && _vm.currentSlider === 1,
                        "vue-slider-dot-disabled":
                          !_vm.boolDisabled && _vm.disabledArray[1],
                      },
                    ],
                    style: _vm.dotStyles,
                    on: {
                      mousedown: function ($event) {
                        return _vm.moveStart($event, 1)
                      },
                      touchstart: function ($event) {
                        return _vm.moveStart($event, 1)
                      },
                    },
                  },
                  [
                    _vm._t(
                      "dot",
                      [
                        _c("div", {
                          staticClass: "vue-slider-dot-handle",
                          style: [
                            !_vm.boolDisabled && _vm.disabledArray[1]
                              ? _vm.disabledDotStyles[1]
                              : null,
                            _vm.sliderStyles[1],
                            _vm.focusFlag && _vm.focusSlider === 1
                              ? _vm.focusStyles[1]
                              : null,
                          ],
                        }),
                      ],
                      {
                        value: _vm.val[1],
                        index: 1,
                        disabled: _vm.disabledArray[1],
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "tooltip1",
                        class: [
                          "vue-slider-tooltip-" + _vm.tooltipDirection[1],
                          "vue-slider-tooltip-wrap",
                        ],
                      },
                      [
                        _vm._t(
                          "tooltip",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "vue-slider-tooltip",
                                class: _vm.tooltipClass,
                                style: _vm.tooltipStyles[1],
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatter
                                      ? _vm.formatting(_vm.val[1])
                                      : _vm.val[1]
                                  )
                                ),
                              ]
                            ),
                          ],
                          {
                            value: _vm.val[1],
                            index: 1,
                            disabled: !_vm.boolDisabled && _vm.disabledArray[1],
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ]
            : [
                _vm.staticValue !== void 0
                  ? _c(
                      "div",
                      {
                        key: "static-dot",
                        ref: "static-dot",
                        staticClass: "vue-slider-dot static-dot",
                        class: [
                          "vue-slider-dot",
                          "vue-slider-dot--static",
                          {
                            "vue-slider-dot-active": _vm.isActive(
                              _vm.getIndexByValue(_vm.staticValue)
                            ),
                          },
                        ],
                        style: [_vm.staticPosition, _vm.dotStyles],
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return (function () {
                              return (
                                _vm.clickable && _vm.setValue(_vm.staticValue)
                              )
                            })($event)
                          },
                        },
                      },
                      [
                        _vm._t(
                          "static-dot",
                          [
                            _c("div", {
                              staticClass: "vue-slider-dot-handle--static",
                            }),
                          ],
                          { value: _vm.staticValue }
                        ),
                        _vm._v(" "),
                        _vm.val !== _vm.staticValue
                          ? _c(
                              "div",
                              {
                                class: [
                                  "vue-slider-tooltip-" + _vm.tooltipDirection,
                                  "vue-slider-tooltip-wrap",
                                ],
                              },
                              [
                                _vm._t(
                                  "static-tooltip",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "vue-slider-tooltip",
                                        class: _vm.tooltipClass,
                                      },
                                      [
                                        _vm.staticLabel
                                          ? [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(_vm.staticLabel) +
                                                  "\n              "
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.formatter
                                                      ? _vm.formatting(
                                                          _vm.staticValue
                                                        )
                                                      : _vm.staticValue
                                                  ) +
                                                  "\n              "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ],
                                  { value: _vm.staticValue }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    key: "dot",
                    ref: "dot",
                    class: [
                      _vm.tooltipStatus,
                      "vue-slider-dot",
                      {
                        "vue-slider-dot-focus":
                          _vm.focusFlag && _vm.focusSlider === 0,
                        "vue-slider-dot-dragging":
                          _vm.flag && _vm.currentSlider === 0,
                      },
                    ],
                    style: _vm.dotStyles,
                    on: { mousedown: _vm.moveStart, touchstart: _vm.moveStart },
                  },
                  [
                    _vm._t(
                      "dot",
                      [
                        _c("div", {
                          staticClass: "vue-slider-dot-handle",
                          style: [
                            _vm.sliderStyles,
                            _vm.focusFlag && _vm.focusSlider === 0
                              ? _vm.focusStyles
                              : null,
                          ],
                        }),
                      ],
                      { value: _vm.val, disabled: _vm.boolDisabled }
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "vue-slider-tooltip-" + _vm.tooltipDirection,
                          "vue-slider-tooltip-wrap",
                        ],
                      },
                      [
                        _vm._t(
                          "tooltip",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "vue-slider-tooltip",
                                class: _vm.tooltipClass,
                                style: _vm.tooltipStyles,
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatter
                                      ? _vm.formatting(_vm.val)
                                      : _vm.val
                                  )
                                ),
                              ]
                            ),
                          ],
                          { value: _vm.val }
                        ),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ],
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "vue-slider-piecewise" },
            _vm._l(_vm.piecewiseDotWrap, function (piecewiseObj, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "vue-slider-piecewise-item",
                  style: [_vm.piecewiseDotStyle, piecewiseObj.style],
                },
                [
                  _vm._t(
                    "piecewise",
                    [
                      _vm.piecewise
                        ? _c("span", {
                            class: [
                              "vue-slider-piecewise-dot",
                              {
                                "vue-slider-piecewise-dot-active": _vm.isActive(
                                  piecewiseObj.index
                                ),
                              },
                            ],
                            style: [
                              _vm.piecewiseStyle,
                              _vm.isActive(piecewiseObj.index)
                                ? _vm.piecewiseActiveStyle
                                : null,
                            ],
                          })
                        : _vm._e(),
                    ],
                    {
                      value: _vm.val,
                      label: piecewiseObj.label,
                      index: index,
                      first: index === 0,
                      last: index === _vm.piecewiseDotWrap.length - 1,
                      active: _vm.isActive(piecewiseObj.index),
                      total: _vm.piecewiseDotWrap.length,
                    }
                  ),
                  _vm._v(" "),
                  _vm._t(
                    "label",
                    [
                      _vm.piecewiseLabel
                        ? _c(
                            "span",
                            {
                              staticClass: "vue-slider-piecewise-label",
                              style: [
                                _vm.labelStyle,
                                _vm.isActive(piecewiseObj.index)
                                  ? _vm.labelActiveStyle
                                  : null,
                              ],
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(piecewiseObj.label) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    {
                      value: _vm.val,
                      label: piecewiseObj.label,
                      index: index,
                      first: index === 0,
                      last: index === _vm.piecewiseDotWrap.length - 1,
                      active: _vm.isActive(piecewiseObj.index),
                      total: _vm.piecewiseDotWrap.length,
                    }
                  ),
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "process",
              class: [
                "vue-slider-process",
                {
                  "vue-slider-process-dragable":
                    _vm.isRange && _vm.processDragable,
                },
                _vm.processClass,
              ],
              style: _vm.processStyle,
              on: {
                click: _vm.processClick,
                mousedown: function ($event) {
                  return _vm.moveStart($event, 0, true)
                },
                touchstart: function ($event) {
                  return _vm.moveStart($event, 0, true)
                },
              },
            },
            [
              _c(
                "div",
                {
                  ref: "mergedTooltip",
                  class: [
                    "vue-merged-tooltip",
                    "vue-slider-tooltip-" + _vm.tooltipDirection[0],
                    "vue-slider-tooltip-wrap",
                  ],
                  style: _vm.tooltipMergedPosition,
                },
                [
                  _vm._t(
                    "tooltip",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "vue-slider-tooltip",
                          class: _vm.tooltipClass,
                          style: _vm.tooltipStyles,
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.mergeFormatter
                                  ? _vm.mergeFormatting(_vm.val[0], _vm.val[1])
                                  : _vm.formatter
                                  ? _vm.val[0] === _vm.val[1]
                                    ? _vm.formatting(_vm.val[0])
                                    : _vm.formatting(_vm.val[0]) +
                                      " - " +
                                      _vm.formatting(_vm.val[1])
                                  : _vm.val[0] === _vm.val[1]
                                  ? _vm.val[0]
                                  : _vm.val[0] + " - " + _vm.val[1]
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    { value: _vm.val, merge: true }
                  ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.isRange && !_vm.data
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.val,
                    expression: "val",
                  },
                ],
                staticClass: "vue-slider-sr-only",
                attrs: { type: "range", min: _vm.min, max: _vm.max },
                domProps: { value: _vm.val },
                on: {
                  __r: function ($event) {
                    _vm.val = $event.target.value
                  },
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }